import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs/Observable';

import {HttpBase} from 'app/services/http-base.service';
import {Versions} from 'app/shared/models/vesions';
import { CodeName } from 'app/stocks/models/code-name'

import * as moment from 'moment';
import {StocksFilter} from "../models/stocks-filter";
import {FilterControlSettings} from "../models/filter-control-settings";
import {AdditionalFilterData} from "../models/additional-filter-data";
import {InfoPanel} from "../models/info-panel";
import {StocksColumnSettingsBase} from "../../slick-grid/models/column-settings-base";


type Permissions = { accessDenied: boolean, permissions: {isAdmin: boolean, versionNotCompatible: boolean }, filterSettings: FilterControlSettings[], filterJson: string, separator: string, data: AdditionalFilterData[], stocksSettings: StocksColumnSettingsBase[], activePreset: string, presets: string };

type ApplyFilter = { success: string, dynamicDt: any };

type List = { accessDenied: boolean, view: boolean, add: boolean, versionNotCompatible: boolean };

type SendExcel = { accessDenied: boolean, success: boolean, message: string };

type GenerateExcel = { accessDenied: boolean, success: boolean, url: string, fileName: string };

type infoPanel = { accessDenied: boolean, success: boolean, itemInfo: InfoPanel[] };

@Injectable()
export class StocksService extends HttpBase{
    constructor(http: HttpClient, router: Router, translateService: TranslateService){
        super(http, router, translateService);
    };



    // GetDataForCodeNameFilter = (funcName: string, filter: any): Observable<CodeName[]> =>{
    //     //let param = level ? {params: {level}} : {};
    //     console.log(funcName, filter, 'GetDataForCodeNameFilter');
    //     return this.get<CodeName[]>('/api/stocksfilter/' + funcName, { params: {level: filter}}).map(data =>{
    //         if (data && data.length)
    //             data = data.map( (p, i) => new CodeName(
    //                 i + 1,
    //                 false,
    //                 p.code,
    //                 p.name
    //             ));
    //         return data;
    //     });
    // };

    /*ApplyAssortment = (data: IaInsertDataExcelChecked[], description: string): Observable<SaveResult> =>{
        return this.post<SaveResult>('/api/asmtinput/applyregistry', {
            data: data,
            description: description
        })
    };

    CheckChangeBuffer = (data: IaInsertData[]): Observable<CheckResult> =>{
        return this.post<CheckResult>('/api/asmtinput/checkregistry', {
            data: data
        });
    };

    GenerateExcelTable = (data: IaInsertDataExcelChecked[], dataType: string): Observable<GenerateExcel> =>{
        return this.post<GenerateExcel>('/api/asmtinput/generateexcel', {
            data: data,
            dataType: dataType
        });
    };

    SendExcelTable = (data: IaInsertDataExcelChecked[], dataType: string): Observable<SendExcel> =>{
        return this.post<SendExcel>('/api/asmtinput/sendexcel', {
            data: data,
            dataType: dataType
        });
    };

    GenerateAppliedDataExcel = (id: string): Observable<GenerateExcel> =>{
        return this.post<GenerateExcel>('/api/asmtinput/generateapplieddataexcel', {id: id});
    };

    SendAppliedDataExcel = (id: string): Observable<SendExcel> =>{
        return this.post<SendExcel>('/api/asmtinput/sendapplieddataexcel', {id: id});
    };

    SaveExcelMistakes = (url): Observable<any> =>{
        return this.get<any>(url, {responseType: 'blob'});
    };*/

    GetPermissions = (): Observable<List> =>{
        //return this.get<Permissions>('/api/asmtinput/getpermissions', {params: {moduleName: 'Stocks' , version: new Versions().stocks }});
        return this.get<List>('/api/buffertable/getpermissions', {params: {moduleName: 'BufferTableExcel' , version: new Versions().bufferTableExcel }});
    };

    //# get initialise data for stocks
    Index = (): Observable<Permissions> =>{
        return this.get<Permissions>('/api/stocksfilter/index', {params: {moduleName: 'Stocks' , version: new Versions().stocks }});
    };

    //# apply main filter
    ApplyFilter = (data: string, columns: string): Observable<ApplyFilter> =>{
        return this.post<ApplyFilter>('/api/stockstable/applyfilter', {data, columns});
    };

    //# save active preset name
    SaveCurrentPresetName = (presetName: string): Observable<string> =>{
        return this.post<string>('/api/stockstable/updatelastusedpreset', { data: presetName });
    };

    //# save preset
    SavePreset = (presetJson: string): Observable<{success: boolean}> =>{
        return this.post<{success: boolean}>('/api/stockstable/savepreset', { data: presetJson });
    };

    //# send excel to email, view grid
    SendExcel = (data: any[], columns: string[]): Observable<SendExcel> =>{
        return this.post<SendExcel>('/api/stockstable/sendexcel', { data, columns });
    };

    //# get url for download excel
    SaveToExcel = (data: any[], columns: string[]): Observable<GenerateExcel> =>{
        return this.post<GenerateExcel>('/api/stockstable/savetoexcel', { data, columns });
    };

    //# download excel by url
    SaveExcelFile = (url): Observable<any> =>{
        return this.get<any>(url, {responseType: 'blob'});
    };

    //# get summary by itemID
    GetSummary = (itemId: number[]): Observable<string> =>{
        return this.post<string>('/api/stockstable/getsummary', itemId);
    };

    //# get data for infopanel tab
    InfoPanelData = (itemId: number, startDate: string, endDate: string ): Observable<infoPanel> =>{
        return this.get<infoPanel>('/api/buffergraphdata/getiteminfo', {params: {itemId, dateStart: startDate, dateEnd: endDate}})
    };

    //# delete preset
    DeletePreset = (presetName: string[]): Observable<{success: boolean}> =>{
        return this.post<{success: boolean}>('/api/stockstable/deletepreset', presetName);
    };

    //# get url for download excel
    GenerateInfoPanelExcel = (itemId: number, startDate?: string, endDate?: string): Observable<GenerateExcel> =>{
        return this.get<GenerateExcel>('/api/buffergraphdata/generateinfopanelexcel', {params: {itemId, dateStart: startDate, dateEnd: endDate}});
    };

    //# send excel to email, infopanel
    SendInfoPanelExcel = (itemId: number, startDate?: string, endDate?: string): Observable<SendExcel> =>{
        return this.get<SendExcel>('/api/buffergraphdata/sendinfopanelexcel', {params: {itemId, dateStart: startDate, dateEnd: endDate}});
    };

    //# download excel by url
    SaveExcel = (url): Observable<any> =>{
        return this.get<any>(url, {responseType: 'blob'});
    };
}




// WEBPACK FOOTER //
// ./src/app/stocks/services/stocks.service.ts